import {
  EventSource,
  Principal_Read_Nested,
  ProjectEvent_Read,
  ProjectEventName,
  ProjectState,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { createdBy as principalName } from '~components/Job/AuditDetails/utils';
import { Nullable } from '~types/Nullable';

type ProjectEventPayload = ProjectEvent_Read['payload'];

export class ProjectEvent {
  public static parse(proto: ProjectEvent_Read) {
    return new ProjectEvent(
      proto.id,
      proto.event_name,
      proto.event_source,
      proto.project_state ?? null,
      proto.created_by ?? null,
      dayjs(proto.created_at),
      dayjs(proto.occurred_at),
      proto.payload ?? null,
    );
  }

  public get id() {
    return this._id;
  }

  public get eventName() {
    return this._event_name;
  }

  public get eventSource() {
    return this._event_source;
  }

  public get projectState() {
    return this._project_state;
  }

  public get createdBy() {
    return this._created_by;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get occurredAt() {
    return this._occurred_at;
  }

  public get payload() {
    return this._payload;
  }

  public get createdByName() {
    return this._created_by ? principalName(this._created_by) : '';
  }

  constructor(
    private _id: string | undefined,
    private _event_name: ProjectEventName,
    private _event_source: EventSource,
    private _project_state: Nullable<ProjectState>,
    private _created_by: Nullable<Principal_Read_Nested>,
    private _created_at: Dayjs,
    private _occurred_at: Dayjs,
    private _payload: ProjectEventPayload,
  ) {}
}
